import {
  DEFAULT_ISLAND_KEY,
  getIslandHomepageHeroEntries,
  getIslandHomepageHeroLibrary,
} from 'alakai-aloha-shared';

export const getHeroBackgroundImages = (
  islandKey = DEFAULT_ISLAND_KEY,
  options = {},
) => getIslandHomepageHeroEntries(islandKey, options).map((entry) => entry.src);

export const getHeroBackgroundImageEntries = (
  islandKey = DEFAULT_ISLAND_KEY,
  options = {},
) => getIslandHomepageHeroEntries(islandKey, options);

export const getHeroBackgroundLibrary = (
  islandKey = DEFAULT_ISLAND_KEY,
  options = {},
) => getIslandHomepageHeroLibrary(islandKey, options);

export const heroBackgroundImages = getHeroBackgroundImages();
